import React from "react";
import Roll from "../../assets/icons/Roll";

export default function PDFGenerationScreen({
  visible,
  name="",
  activity="",
  format=""
 
}) {

  if(visible){
    console.log("Step 1.1.1 : hourglass screen was triggered");
  }
  

  if (!visible) return null;
  return (
    <>
      <div
        id="modal"
        // onClick={handleOnClose}
        className="bg-black bg-opacity-20 fixed z-50 inset-0  flex justify-center items-center cursor-wait "
      >
        <div className="bg-white mt-12 p-4 rounded-xl w-4/12 animate-zoom-in">
        <div className=" flex justify-center items-center my-4">
            <Roll/>
        </div>
          <div className=" w-full  text-gray-600">
            <p className=" font-semibold my-3  text-3xl text-center">{`Report generation in progress…`}</p>
             <p className=" font-medium text-lg my-6 text-center">{`${activity || ""} report is being generated in ${format || ""} format in Standard ${name || ""}.`}</p>
          </div>
        </div>
      </div>
    </>
  );
}
